// extracted by mini-css-extract-plugin
export default {"dialog-content":"dialog-content__ec6Q7","dialog":"dialog__36-PY","dialog-title":"dialog-title__U5Yei","actions":"actions__sG+20","btn":"btn__IowLV"};